import { defineMessages } from 'react-intl';

export const i18n = defineMessages({
	rovoAwarenessMessage: {
		id: 'ai-awareness.rovoAwarenessMessage',
		defaultMessage: 'Summary by Rovo',
		description:
			'Attribution label displayed near AI-generated summaries to indicate the content was created by Rovo.',
	},
	rovoAwarenessDefineMessage: {
		id: 'ai-awareness-define.message',
		defaultMessage: 'Definition by Rovo',
		description:
			'Attribution label displayed near AI-generated definitions to indicate the content was provided by Rovo.',
	},
});
